import { Action, Module, VuexModule } from "vuex-module-decorators";
import { HistoryQuestions } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class HistoryQuestionsModule extends VuexModule {
    @Action
    [HistoryQuestions.findPageHistoryQuestions](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/historyQuestions/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [HistoryQuestions.saveHistoryQuestions](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/historyQuestions/save`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [HistoryQuestions.deleteHistoryQuestions](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/historyQuestions/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}